import { useEffect, useRef, useState } from "react";
import { isManagedNode, managedNodes } from "../positions/managedNodes";
function buildContext(nodes) {
    return {
        nodes,
        nodeById: new Map(nodes.map((n)=>[
                n.id,
                n
            ]))
    };
}
export function useSeedAlgoOnReady(options) {
    const { enabled, assembly, adapter, manager, laneLayout, initialSavedHas, buildInitialAssembly } = options;
    const didSeedRef = useRef(false);
    const [isSeeding, setIsSeeding] = useState(()=>{
        if (!enabled) return false;
        const initial = buildInitialAssembly();
        if (initial.nodes.length === 0) return false;
        return managedNodes(initial.nodes, laneLayout?.isLane).some((n)=>!initialSavedHas(n.id));
    });
    useEffect(function seedLayoutForUnsavedNodes() {
        if (!enabled) return;
        if (didSeedRef.current) return;
        if (assembly.nodes.length === 0) {
            didSeedRef.current = true;
            setIsSeeding(false);
            return;
        }
        const isLane = laneLayout?.isLane;
        const unsaved = managedNodes(assembly.nodes, isLane).filter((n)=>!manager.hasSaved(n.id));
        if (unsaved.length === 0) {
            didSeedRef.current = true;
            setIsSeeding(false);
            return;
        }
        let cancelled = false;
        void (async ()=>{
            const positioned = await adapter.layout.run(assembly);
            if (cancelled) return;
            didSeedRef.current = true;
            const updates = [];
            for (const n of positioned.nodes){
                if (!isManagedNode(n, isLane)) continue;
                if (!manager.hasSaved(n.id)) {
                    updates.push({
                        id: n.id,
                        position: n.position
                    });
                }
            }
            if (updates.length > 0) {
                manager.seedSaved(updates, buildContext(positioned.nodes));
            }
            setIsSeeding(false);
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        enabled,
        assembly,
        adapter,
        manager,
        laneLayout
    ]);
    return {
        isSeeding
    };
}

//# sourceMappingURL=useSeedAlgoOnReady.js.map